import { getEnv } from '$environments';
import { setupPendo } from '$lib/helpers/pendo.js';

export const env = getEnv();
if (env.pendoApiKey) {
	setupPendo(env.pendoApiKey);
}
